import React from 'react';
import { CheckCircle, Clock, DollarSign, Heart, Users, Zap } from 'lucide-react';

const Benefits = ({ language }) => {
  const texts = {
    no: {
      title: 'Hvorfor velge CulinaryAI24?',
      subtitle: 'Opplev fremtiden for matlaging med vår avanserte AI-teknologi',
      benefits: [
        {
          icon: Clock,
          title: 'Spar tid',
          description: 'Ingen mer tid brukt på å planlegge måltider. Få oppskrifter på sekunder.'
        },
        {
          icon: DollarSign,
          title: 'Reduser matsvinn',
          description: 'Bruk opp alle ingrediensene dine med smarte oppskrifter som minimerer avfall.'
        },
        {
          icon: Heart,
          title: 'Sunnere valg',
          description: 'AI anbefaler balanserte måltider basert på dine ingredienser og helsemål.'
        },
        {
          icon: Users,
          title: 'Familievennlig',
          description: 'Få oppskrifter som passer hele familien, inkludert allergier og preferanser.'
        },
        {
          icon: Zap,
          title: 'Alltid tilgjengelig',
          description: '24/7 tilgang til AI-kokken din, når som helst, hvor som helst.'
        },
        {
          icon: CheckCircle,
          title: 'Enkel å bruke',
          description: 'Intuitivt design som gjør matlaging tilbake til det det skal være - gøy!'
        }
      ]
    },
    en: {
      title: 'Why Choose CulinaryAI24?',
      subtitle: 'Experience the future of cooking with our advanced AI technology',
      benefits: [
        {
          icon: Clock,
          title: 'Save Time',
          description: 'No more time spent meal planning. Get recipes in seconds.'
        },
        {
          icon: DollarSign,
          title: 'Reduce Waste',
          description: 'Use up all your ingredients with smart recipes that minimize waste.'
        },
        {
          icon: Heart,
          title: 'Healthier Choices',
          description: 'AI recommends balanced meals based on your ingredients and health goals.'
        },
        {
          icon: Users,
          title: 'Family Friendly',
          description: 'Get recipes that work for the whole family, including allergies and preferences.'
        },
        {
          icon: Zap,
          title: 'Always Available',
          description: '24/7 access to your AI chef, anytime, anywhere.'
        },
        {
          icon: CheckCircle,
          title: 'Easy to Use',
          description: 'Intuitive design that makes cooking what it should be - fun!'
        }
      ]
    }
  };

  const t = texts[language];

  return (
    <section id="section-4" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.benefits.map((benefit, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-green-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <benefit.icon className="w-8 h-8 text-white" />
              </div>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {benefit.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        {/* App Preview */}
        <div className="mt-16 text-center">
          <div className="relative inline-block">
            <img
              src="/images/app-recipe-display.png"
              alt="App showing recipe results"
              className="w-full max-w-lg rounded-2xl shadow-2xl"
            />
            <div className="absolute -top-4 -left-4 bg-green-600 text-white px-6 py-3 rounded-full text-lg font-semibold shadow-lg">
              {language === 'no' ? 'AI-genererte oppskrifter' : 'AI-Generated Recipes'}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
